module.exports = ":host {\n  margin-left: 10px;\n  position: relative;\n  display: inline-block;\n  float: left; }\n  :host input {\n    display: inline-block;\n    width: auto;\n    position: absolute;\n    outline: 0 none;\n    box-shadow: none;\n    opacity: 0;\n    z-index: -1; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/search/category-filter/category-filter.style.scss
// module id = 691
// module chunks = 2